module.exports = __webpack_public_path__ + "dashboard/img/summary.fa9da3b846c836a26e11e1ba138e0068.svg";